(() => {
 if(window.westyProductDesignReady)return;
 window.westyProductDesignReady=true;
 const initBeds=()=>document.querySelectorAll('[data-wh-bed]:not([data-wh-ready])').forEach(bed=>{
  bed.dataset.whReady='true';
  let recent=[];try{recent=JSON.parse(sessionStorage.getItem('westyViewedProducts')||'[]');if(!Array.isArray(recent))recent=[];}catch{}
  bed.dataset.whRecent=JSON.stringify(recent.filter(h=>h!==bed.dataset.currentHandle));
  try{sessionStorage.setItem('westyViewedProducts',JSON.stringify([bed.dataset.currentHandle,...recent.filter(h=>h!==bed.dataset.currentHandle)].slice(0,12)));}catch{}
 });
 initBeds();new MutationObserver(initBeds).observe(document.documentElement,{childList:true,subtree:true});
 document.addEventListener('click',e=>{
  const target=e.target instanceof Element?e.target:null;
  if(!target)return;
  const bedTab=target.closest('[data-wh-bed-tab]');
  if(bedTab){const bed=bedTab.closest('[data-wh-bed]');const recent=JSON.parse(bed.dataset.whRecent||'[]');let shown=0;bed.querySelectorAll('[data-wh-bed-tab]').forEach(b=>b.setAttribute('aria-selected',String(b===bedTab)));bed.querySelectorAll('[data-wh-bed-handle]').forEach(card=>{const visible=bedTab.dataset.whBedTab==='recent'?recent.includes(card.dataset.whBedHandle):card.dataset.whRecommended==='true';card.hidden=!visible;if(visible)shown++;});bed.querySelector('.wh-complete-bed__empty').hidden=shown>0;bed.querySelector('[data-wh-track]').scrollLeft=0;}

  if(target.closest('[data-wh-size-guide]')){
   const details=document.querySelector('[data-wh-sizing]');
   if(details){details.open=true;details.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});details.querySelector('summary')?.focus();}
  }
  const arrow=target.closest('[data-wh-prev],[data-wh-next]');
  if(arrow){const track=arrow.closest('[data-wh-rail]')?.querySelector('[data-wh-track]');if(track)track.scrollBy({left:track.clientWidth*(arrow.hasAttribute('data-wh-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 });
})();

// Enhance the CSS-only comparison without letting hidden radios steal focus.
(() => {
  if (window.westyComparisonTabsReady) return;
  window.westyComparisonTabsReady = true;

  const groups = new WeakMap();
  const groupSelector = '.wh-reference-tabs';
  const tabSelector = '[data-wh-compare-tab]';
  const historyKey = 'westyComparisonTabs';

  function savedSelection(group) {
    return window.history.state?.[historyKey]?.[group.key];
  }

  function activate(group, index, { focus = false, remember = false } = {}) {
    const active = group.items[index];
    if (!active) return;
    group.items.forEach(({ input, tab, panel }, itemIndex) => {
      const selected = itemIndex === index;
      input.checked = selected;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      panel.hidden = !selected;
      panel.style.display = selected ? 'grid' : 'none';
    });
    // The original label focuses an absolutely positioned, invisible input.
    // Keep focus on the visible control and preserve both page scroll containers.
    if (focus) active.tab.focus({ preventScroll: true });
    if (remember) {
      try {
        const state = window.history.state || {};
        window.history.replaceState({
          ...state,
          [historyKey]: { ...state[historyKey], [group.key]: active.tab.textContent.trim() }
        }, '', window.location.href);
      } catch (error) {
        // Browsers may restrict history updates. Switching the panel still works.
      }
    }
  }

  function initComparison(element) {
    if (groups.has(element)) return groups.get(element);
    const items = Array.from(element.children)
      .filter((child) => child.matches('.wh-reference-tab-input'))
      .map((input) => ({ input, tab: input.nextElementSibling, panel: input.nextElementSibling?.nextElementSibling }))
      .filter(({ tab, panel }) => tab?.matches('label') && panel?.matches('.wh-reference-panel'));
    if (!items.length) return null;
    const group = { element, items, key: items[0].input.name };
    groups.set(element, group);
    element.setAttribute('role', 'tablist');
    element.setAttribute('aria-label', element.closest('.wh-reference-compare')?.querySelector('h2')?.textContent.trim() || 'Compare bedding');
    items.forEach(({ input, tab, panel }) => {
      input.hidden = true;
      input.style.display = 'none';
      input.tabIndex = -1;
      input.setAttribute('aria-hidden', 'true');
      tab.dataset.whCompareTab = '';
      tab.id = `${input.id}-tab`;
      tab.setAttribute('role', 'tab');
      panel.id = `${input.id}-panel`;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.tabIndex = 0;
      tab.setAttribute('aria-controls', panel.id);
    });
    const saved = savedSelection(group);
    const savedIndex = items.findIndex(({ tab }) => tab.textContent.trim() === saved);
    const checkedIndex = items.findIndex(({ input }) => input.checked);
    activate(group, savedIndex >= 0 ? savedIndex : Math.max(0, checkedIndex));
    return group;
  }

  function initComparisons() {
    document.querySelectorAll(groupSelector).forEach(initComparison);
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const tab = target?.closest(`${groupSelector} > label`);
    if (!tab || event.button > 0) return;
    const group = initComparison(tab.parentElement);
    const index = group?.items.findIndex((item) => item.tab === tab) ?? -1;
    if (index < 0) return;
    event.preventDefault();
    activate(group, index, { focus: true, remember: true });
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const tab = target?.closest(tabSelector);
    if (!tab || event.altKey || event.ctrlKey || event.metaKey) return;
    const group = groups.get(tab.parentElement);
    if (!group) return;
    const index = group.items.findIndex((item) => item.tab === tab);
    const last = group.items.length - 1;
    const rtl = getComputedStyle(group.element).direction === 'rtl';
    let next = index;
    switch (event.key) {
      case 'ArrowRight': next = (index + (rtl ? last : 1)) % group.items.length; break;
      case 'ArrowLeft': next = (index + (rtl ? 1 : last)) % group.items.length; break;
      case 'Home': next = 0; break;
      case 'End': next = last; break;
      case 'Enter':
      case ' ': break;
      default: return;
    }
    event.preventDefault();
    activate(group, next, { focus: true, remember: true });
  });

  // Delegated handlers survive colour swaps and browser-history product renders.
  initComparisons();
  new MutationObserver(initComparisons).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('westy:product-changed', initComparisons);
  document.addEventListener('shopify:section:load', initComparisons);
  window.addEventListener('pageshow', initComparisons);
})();
